import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _favoriteControls: {
      name: '',
      width: '4rem',
    },
    _primaryControls: {
      name: '',
      width: '4rem',
    },
    _imageDisplay: {
      name: 'รายละเอียด',
      width: '1fr',
    },
    filename: {
      name: 'ชื่อไฟล์รูปภาพ',
      width: '1fr',
    },
    'uploadedBy.updatedAt': {
      name: 'วันที่แก้ไข',
      width: '12rem',
    },
    'uploadedBy.createdAt': {
      name: 'วันที่อัปโหลด',
      width: '12rem',
    },
    'uploadedBy.username': {
      name: 'ผู้อัปโหลด',
      width: '8rem',
    },
    _downloadControls: {
      name: '',
      width: '4rem',
    },
  },
  columns: ['_primaryControls', '_imageDisplay', 'filename', 'uploadedBy.updatedAt', 'uploadedBy.createdAt', 'uploadedBy.username', '_downloadControls'],
  // sortable: [],
};
